import React from 'react';

export interface SessionCardPinContextProps {
  pinnedAt: number;
  pin: () => void;
  unpin: () => void;
}

export const SessionCardPinContext = React.createContext<SessionCardPinContextProps | null>(undefined);

export default function useSessionCardPinContext() {
  const context = React.useContext(SessionCardPinContext);
  if (!context) {
    throw new Error('useSessionCardPinContext must be used within a SessionCardPinContextProvider');
  }
  return context;
}
